import React from 'react';
import PropTypes from 'prop-types';
import MoneyBagIcon from '../../icons/icon-money-bag.svg';
import CustomReactMarkdown from '../MarkdownRenderers/CustomReactMarkdown';


const PromotionBanner = function PromotionBannerComponent({
  markdown,
  bannerClasses,
}) {
  return (
    <div className={`promo-banner ${bannerClasses}`}>
      <MoneyBagIcon className="money-bag-icon" />
      <div className="promo-banner__message-wrapper">
        <CustomReactMarkdown source={markdown} />
      </div>
    </div>
  );
};

PromotionBanner.propTypes = {
  markdown: PropTypes.string.isRequired,
  bannerClasses: PropTypes.string,
};

PromotionBanner.defaultProps = {
  bannerClasses: '',
};

export default PromotionBanner;
